import { render, staticRenderFns } from "./StatusIcons.vue?vue&type=template&id=32584ab5&scoped=true&"
import script from "./StatusIcons.vue?vue&type=script&lang=js&"
export * from "./StatusIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32584ab5",
  null
  
)

export default component.exports